import { useGetOne } from "@mb-pro-ui/utils";
import { related, type Operator, type Org, type User } from "./types";

const include = { org: {}, "alarm-operator": {} } as const;
const fields = {
  users: ["name", "username", "admin", "ui-language", "org", "+alarm-operator", "+allowed-orgs"],
  orgs: ["name"],
  operators: ["admin", "customer-manager-right", "+field-blacklists"],
} as const;

// Under an org scope this is the local user the session acts as in that org,
// so the operator rights are the ones the backend applies there. Outside of
// it (and only there) `allowed-orgs` lists the orgs the session may act in.
export function useMe() {
  return useGetOne<User>("admin/users", "me", {
    include,
    fields,
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
}

export function homeOrgName(me: User | undefined) {
  return related<Org>(me?.org)?.name ?? null;
}

export function operatorOf(me: User | undefined) {
  return related<Operator>(me?.["alarm-operator"]);
}

export function canReadCustomerDatasheet(me: User | undefined) {
  const operator = operatorOf(me);
  return !!(me?.admin || operator?.admin || operator?.["customer-manager-right"]);
}
